import { Center, Heading, Image, Spacer, StatusBar, Text } from 'native-base';
import PropTypes from 'prop-types';
import React from 'react';
import { SwipeListView } from 'react-native-swipe-list-view';

import HistoryItem from './HistoryItem';
import HistoryOptions from './HistoryOptions';
import imagePay from '../../../../assets/images/pay.png';
import ActionButton from '../../../shared/ActionButton';

function ViewHistory({ payments, onPay }) {
  if (payments.length > 0) {
    return (
      <>
        <StatusBar backgroundColor="#F4F8FB" barStyle="dark-content" />
        <Center bg="#F4F8FB" shadow="3" px="4" py="4">
          <Heading size="xl">Paiements</Heading>
        </Center>
        <Center bg="#caf0f8" px="4" py="2">
          <Text>Historique de vos paiements.</Text>
        </Center>
        <SwipeListView
          data={payments}
          renderItem={(data) => <HistoryItem key={data.key} item={data.item} />}
          renderHiddenItem={(data) => (
            <HistoryOptions key={data.key} item={data.item} />
          )}
          rightOpenValue={-60}
        />
        <ActionButton onPress={onPay}>Nouveau paiement</ActionButton>
      </>
    );
  }
  return (
    <>
      <StatusBar backgroundColor="#ffffff" barStyle="dark-content" />
      <Spacer />
      <Center px="4">
        <Image source={imagePay} alt="NA" width="300" height="300" mb="3" />
        <Heading textAlign="center">
          Vous n'avez pas encore effectué de paiement.
        </Heading>
      </Center>
      <Spacer />
      <ActionButton onPress={onPay}>Nouveau paiement</ActionButton>
    </>
  );
}

ViewHistory.propTypes = {
  onPay: PropTypes.func.isRequired,
  payments: PropTypes.array.isRequired,
};

export default ViewHistory;
